import { AccordionProps } from '@slal/ui/display';
import { StyledAccordion } from './styles';

export const Accordion = ({ children, ...otherProps }: AccordionProps) => {
    return <StyledAccordion {...otherProps}>{children}</StyledAccordion>;
};
